import React, {useState} from 'react'

import './Clock.css'
import {useInterval} from 'usehooks-ts'
import dayjs from 'dayjs'
import {useCurrentUserRegions} from '@therms/react-modules'

const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

function getDateTime() {
  const date = dayjs()

  return [
    date.format('MMM D'),
    date.format('dddd'),
    date.format('h:mm:ss'),
    date.format('a'),
  ]
}

function Clock() {
  const [[yearDate, dow, time, ordinal], setDateTime] = useState(() =>
    getDateTime(),
  )

  const {currentRegion} = useCurrentUserRegions()

  useInterval(() => {
    setDateTime(getDateTime())
  }, 1000)

  return (
    <div className="clock bg-background p-xxs w-full rounded">
      <div className="px-xs flex justify-between text-sm">
        <span>{yearDate}</span>

        <span>{dow}</span>
      </div>

      <div className="my-xxs text-center text-lg font-bold">
        <span className="text-color-strong">{time}</span>
        <small className="font-light uppercase opacity-30"> {ordinal}</small>
      </div>

      {!!currentRegion && currentRegion.timezone !== browserTimezone && (
        <>
          <div className="border-border border-t" />

          <div className="mt-xs">
            <div className="text-center text-sm font-light">
              <div className="opacity-50">Current Timezone</div>
              <small>{browserTimezone}</small>
            </div>

            <div className="text-center text-sm font-light">
              <div className="inline-flex">
                <span className="flex flex-wrap opacity-50">
                  Region Timezone
                </span>
              </div>

              <div>
                <small>{currentRegion.timezone}</small>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export {Clock}